<template>
  <div id="donor_app" ref="main">
    <div class="text-center p-5" v-if="!ready">
      <b-spinner style="width: 3rem; height: 3rem" />
    </div>
    <template v-else>
      <div v-if="error" class="text-center p-5">
        Your session has timed out.
        <a href="#" @click.prevent="reload">Click here</a> to refresh the page.
      </div>
      <template v-else>
        <div v-if="!show_part2" class="px-5 pt-5">
          <h2 class="text-primary font-weight-bold">Donate to Us</h2>
          <h5 class="text-primary">
            As an IPC registered charity, all donations to HealthServe are 250%
            tax deductible.
          </h5>
        </div>
        <div v-if="step === 1" class="main-header">
          <h2 class="text-primary font-weight-bold">Make a Donation</h2>
          <h5 class="text-primary">
            Thank you for choosing to help our migrant community! We’ll need
            additional information about you. Please fill the form below.
          </h5>
        </div>
        <b-alert show v-if="false">
          <div
            class="d-flex align-items-sm-center flex-column flex-sm-row align-items-stretch"
          >
            <span
              >Logged in as: <br class="d-sm-none" /><strong
                ><u>{{ user.last_name }}, {{ user.first_name }}</u> (<u>{{
                  user.user_email
                }}</u
                >)</strong
              >.</span
            ><b-button
              class="ml-sm-auto my-1 my-sm-0"
              variant="primary"
              href="/dashboard"
              target="_BLANK"
              >Visit Dashboard</b-button
            ><b-button class="ml-sm-1" variant="info" @click="logout"
              >Not you? Logout</b-button
            >
          </div>
        </b-alert>
        <part1
          v-if="show_part1"
          :show_sign_in="donationData.email_only"
          :logged_in="!!user"
          :code_sent="otp.sent"
          :invalid_code="otp.invalid"
          :verifying_code="otp.verifying"
          :anon="donationData.anon"
          :checkout="checkout"
          :fb_link="fb_link"
          :google_link="google_link"
          :donation_data="donationData"
          @next="next_1"
          @get-otp="get_otp"
          @check-otp="check_otp"
          @code-verify-reset="reset_otp"
          @donortype="check_donor_type"
          @emailonly="emailonly"
        />
        <part2
          v-if="show_part2"
          @back="go_back"
          :checkout="checkout"
          :axios="axios"
        />
      </template>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import VueScrollTo from "vue-scrollto";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import vSelect from "vue-select";

import part1 from "./components/part1.vue";
import part2 from "./components/part2.vue";

if (window.Vue) {
  window.Vue.use(BootstrapVue);
  window.Vue.use(IconsPlugin);
  window.Vue.component("v-select", vSelect);
}
export default {
  name: "App",
  components: {
    part1,
    part2,
  },
  props: {
    nonce: String,
  },
  data() {
    let nounce_token = this.nonce;
    return {
      nounce_token,
      stripe_key: null,
      error: false,
      ready: false,
      user: null,
      login: null,
      fb_link: null,
      otp: {
        sent: false,
        invalid: true,
        verifying: false,
      },
      google_link: null,
      stripe: null,
      donationData: {
        anon: false,
        email_only: true,
      },
      checkout: {
        stripe_cards: null,
        stripe_key: null,
        Donor_Type: null,
        Donation_Cash_Value: 100,
        Donation_Frequency: 1,
        Donation_Mode: "Credit / Debit Card",
        Donor_Portal_Remarks: "",
        Donor_NRIC: null,
        Title: null,
        First_Name: "",
        Last_Name: "",
        Donor_Email: "",
        Donor_Phone: "",
        Donor_Address_Line_1: "",
        Donor_Address_Line_2: "",
        Donor_Address_Postal_Code: "",
        Donor_Address_Country: "Singapore",
        Donor_Cheque_Number: "",
        Corporate_UEN: "",
        Corporate_Position: "",
        Corporate_Representatives: [],
        Organisation_Name: "",
        On_Behalf_Of: "",
        On_Behalf_Of_Email: "",
        On_Behalf_Of_Msg: "",
        Tax_Deductable_Receipt: true,
        Tax_Receipt_Email_Copy: false,
        Receipt_Soft_Copy: false,
        Email_Subscribe: true,
        Reference: null,
      },
      step: 0,
    };
  },
  mounted() {
    this.init();
    window.addEventListener("message", (e) => {
      if (e.origin == "https://give.healthserve.org.sg") {
        if (e?.data?.nonce) {
          this.rerun_login(e?.data?.nonce);
        }
      }
    });
  },
  methods: {
    init() {
      this.error = this.ready = false;
      this.refresh_login();
    },
    async refresh_login() {
      await this.axios
        .get("init")
        .then((rsp) => {
          let { data } = rsp;
          this.ready = true;
          Object.assign(this, data);
        })
        .catch(() => {
          this.ready = true;
          this.error = true;
        });
    },
    emailonly() {
      this.donationData.email_only = true;
    },
    check_donor_type(val) {
      if (val == "Anonymous Donor") {
        this.donationData.anon = true;
        return;
      }
      this.donationData.anon = false;
    },
    go_back() {
      if (this.checkout.Reference) {
        let r = confirm(
          "This will clear and cancel the current transaction. Are you sure?"
        );
        if (r) {
          window.location.reload();
          return;
        }
        return;
      }
      this.step = 0;
    },
    reload() {
      window.location.reload();
    },
    logout() {
      this.axios
        .get("logout")
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          window.location.reload();
        });
    },
    get_otp(email) {
      this.axios
        .post("email_otp", { email })
        .then(() => {
          this.otp.sent = true;
        })
        .catch(() => {
          alert("Unable to send the OTP");
        });
    },
    check_otp(data) {
      this.otp.verifying = true;
      this.axios
        .post("otp_login", data)
        .then(async (rsp) => {
          if (rsp.data.valid) {
            this.otp.invalid = false;
            if (rsp.data.new_nonce) {
              await this.rerun_login(rsp.data.new_nonce);
              if (this.user) {
                this.donationData.anon = false;
                alert("Code verified!");
              } else {
                alert("An error has occurred. Reload this page and try again");
              }
            }
            return;
          }
          throw "OTP Invalid";
        })
        .catch(() => {
          this.verifying = false;
          alert("Invalid OTP");
        });
    },
    async rerun_login(nonce) {
      this.nounce_token = nonce;
      await this.refresh_login();
    },
    reset_otp(unsend) {
      this.otp.invalid = true;
      if (unsend) {
        this.otp.sent = false;
      }
    },
    next_1(checkout) {
      Object.assign(this.checkout, checkout);
      this.step = 1;
    },
  },
  computed: {
    axios() {
      return axios.create({
        headers: { "X-WP-Nonce": this.nounce_token },
        baseURL: "/wp-json/tq_donate/v1/",
      });
    },
    show_part1() {
      return (
        this.step === 0 &&
        (this.donationData.anon || this.donationData.email_only || this.login)
      );
    },
    show_part2() {
      return this.step === 1;
    },
  },
  watch: {
    stripe_key(val) {
      this.checkout.stripe_key = val;
    },
    stripe(val) {
      if (val?.cards) {
        this.checkout.stripe_cards = val?.cards;
      }
    },
    step() {
      VueScrollTo.scrollTo(this.$refs.main, 400);
    },
    user: {
      handler() {
        if (this.user) {
          if (this.user.first_name) {
            this.checkout.First_Name = this.user.first_name;
          }
          if (this.user.last_name) {
            this.checkout.Last_Name = this.user.last_name;
          }
          if (this.user.user_email) {
            this.checkout.Donor_Email = this.user.user_email;
          }
          if (this.user.title) {
            this.checkout.Title = this.user.title;
          }

          if (this.user.address_1) {
            this.checkout.Donor_Address_Line_1 = this.user.address_1;
          }
          if (this.user.address_2) {
            this.checkout.Donor_Address_Line_2 = this.user.address_2;
          }
          if (this.user.country) {
            this.checkout.Donor_Address_Country = this.user.country;
          }
          if (this.user.postal) {
            this.checkout.Donor_Address_Postal_Code = this.user.postal;
          }
          if (this.user.mobile) {
            this.checkout.Donor_Phone = this.user.mobile;
          }
          if (!this.user.subscribed) {
            this.checkout.Email_Subscribe = !this.user.subscribed;
          }
          this.donationData.email_only = false;
        }
      },
      deep: true,
    },
    "donationData.anon"(v) {
      if (v) {
        this.checkout.Donor_Type = "Anonymous";
        this.donationData.email_only = false;
      } else {
        this.donationData.email_only = true;
      }
    },
  },
};
</script>

<style lang="scss">
#donor_app {
  font-family: Lato, sans-serif;

  $primary: #9c1d20;
  $hsCrimson: #f4e3dc;

  $theme-colors: (
    "hs-crimson-6": #f8ebe4,
    "hs-pastel-crimson": #f4e3dc,
    "hs-green": #408d94,
    "hs-light-turquoise": #81cacf,
    "hs-black": #333333,
    "hs-dark-gray": #828282,
    "hs-gray": #bdbdbd,
    "hs-light-green": #a2d7dc,
    "hs-dark-turquoise": #3491a8,
  );

  @import "~bootstrap";
  @import "~bootstrap-vue";
  @import "vue-select/src/scss/vue-select.scss";

  .vs__selected-options {
    padding: 0.125rem 0.325rem;
    input::placeholder {
      color: #828282;
    }
  }
  input::placeholder {
    color: #828282;
  }
  @include media-breakpoint-up(md) {
    .split-radio-btns.btn-group > .btn:not(:first-child),
    .split-radio-btns.btn-group > .btn-group:not(:first-child) {
      margin-left: 1rem;
    }
  }
  @include media-breakpoint-down(md) {
    .split-radio-btns.btn-group > .btn,
    .split-radio-btns.btn-group > .btn-group,
    .responsive-radios-btns .btn-group-toggle {
      width: 100%;
      margin-bottom: 0.5rem;
    }

    .responsive-radios-btns .btn-group-toggle .btn {
      width: 100%;
    }
  }
  .cc-table-data tr {
    > td:first-child,
    > th:first-child {
      width: 50px;
      vertical-align: middle;
    }
  }
  .split-radio-btns.btn-group > .btn {
    border-radius: 0.3rem !important;
    padding: 0.5rem 3rem;
  }
  .split-radio-btns.btn-group.narrow > .btn {
    padding: 0.5rem 2rem;
  }
  .split-radio-btns.btn-group > .btn:not(:hover):not(:active):not(.active) {
    background-color: #fff;
  }
  .currency.small {
    font-size: 0.6em;
  }
  .info-bubble {
    background: #ffffff;
    border: 1px solid $primary;
    box-sizing: border-box;
    border-radius: 6px;
    text-align: center;
    padding: 0.5rem 0.7rem;
  }
  .info-caption {
    padding: 0.5rem 0.7rem;
    box-sizing: border-box;
  }
  .split-radio-btns.btn-group {
    flex-wrap: wrap;
  }

  .part-2-fields .form-text {
    margin-left: 0.25rem;
  }
  .pseudo-input {
    position: absolute;
    width: calc(100% - 1px);
    height: calc(100% - 1px);
    border: none;
    border-radius: 5px;
    background: none;
    left: 0%;
    bottom: 0;
    z-index: -1;
    opacity: 0;
  }
  .StripeElement {
    border: 1px solid #ced4da !important;
  }

  .StripeElement--focus {
    border-color: $primary !important;
    outline: 0;
    box-shadow: 0 0 0 0.2rem fade-out($primary, 0.75) !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .vs__search,
  .vs__search:focus {
    width: 0 !important;
    border: 1px solid transparent !important;
    border-left: none !important;
  }
}
</style>
